/**
 * @name text_node
 */

export var text = {
  group: 'inline',
  toDebugString: process.env.NODE_ENV !== 'production' ? undefined : function () {
    return 'text_node';
  }
};